//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    collapse: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    logo: {
      type: String,
      required: true
    }
  }
};